module.exports = __webpack_public_path__ + "static/media/watches-mobile-bg.1e376e30.png";